module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/calendar-badge-outline.a2e28d91.svg";